import numeral from "numeral";
import React from "react";
import {Collapse} from 'react-collapse';

import Chains from "../base/Chains";
import MainUtils from "../main/MainUtils";
import AddressUtils from "../util/AddressUtils";
import LogoUtils from "../util/LogoUtils";
import RespUtils from "../util/RespUtils";

class RelayerUtils extends React.Component {
  static formatRelCount(cell, row) {
    if (!cell) return 0;

    let chains = cell.split(",");
    return chains.length;
  }

  static formatRelChains(cell, row, index, chainConfig) {
    return <Chains chains={cell} relay={true} chainConfig={chainConfig} />;
  }

  static formatRelChainsText(cell, row) {
    if (!cell) return "";

    let chains = cell.replaceAll(",", ", ");
    return chains;
  }

  static formatValChains(cell, row, index, chainConfig) {
    return <Chains chains={cell} relay={false} chainConfig={chainConfig} />;
  }

  static formatValChainsText(cell, row) {
    if (!cell) return "";

    let chains = cell.replaceAll(",", ", ");
    return chains;
  }

  static formatRelChain(cell, row, index, chainConfig) {
    if (!cell) return "";

    return <React.Fragment>
      <Chains chains={cell} label={true} relay={true} chainConfig={chainConfig} />
    </React.Fragment> ;
  }

  static formatRelChainWithStatus(cell, row, index, chainConfig) {
    if (!cell) return "";

    return <React.Fragment>
      <Chains chains={cell} label={true} relay={true} chainConfig={chainConfig} status={row.lastUpdatedGap}/> 
    </React.Fragment> ;
  }

  static getChainStatus(cell) {
    let value = cell;

    let color = "green";
    let desc = "Network data was synced recently.";
    if (value > 1440) {
      color = "red";
      desc = "Network data has not been synced for a long time.";
    } else if (value > 120) {
      color = "orange";
      desc = "Network data has not been synced for few hours.";
    }

    return (<span data-for="main" data-tip={desc} data-iscapture="true"> {MainUtils.colorFormatterOnly(value, color)}</span>);
  }

  static getChainStatusText(cell, row) {
    let value = cell;

    let desc = "Network data was synced recently.";
    if (value > 1440) {
      desc = "Network data has not been synced for a long time.";
    } else if (value > 120) {
      desc = "Network data has not been synced for few hours.";
    }

    return desc;
  }

  static relayerAddressFormatter(address, row, index, chainConfig) {
    if (!address) return "N/A";
    
    let chain = row.app;
    let label = address;

    let length = 5;
    if (RespUtils.isTabletView()) {
      length = 3;
    }

    label = address.substring(0, length) + ". ." + address.substring(address.length - length, address.length);
  
    if (!(chain in chainConfig)) {
      // console.log("link not found for " + chain);
      return label;
    }

    let chainDetails = chainConfig[chain];
    if (chainDetails.explorerAccountPage === null) {
      return label;
    }

    let link = chainDetails.explorerAccountPage + address;

    return (<span><a className="animLink" target="_blank"
      href={link}>{label}</a>
      &nbsp;{AddressUtils.copyLink(address)}</span>);
  }

  static getRelayersNote() {
    return (
      <Collapse isOpened={true}>
        <ul>
          <li>
            The data shown on the dashboard (apart from 'Chains Validated') is captured via pull requests created by relayers on {RelayerUtils.getGithub()}. 
            It is likely that several relayers are missing on this dashboard as they may not be aware of this dashboard. 
            The 'Chains Relayed' feature supports all chains.
          </li>
          <li>
            The 'Chains Validated' data is shown based on data available via other Smart Stake dashboards.
            Several other IBC supporting chains are not covered here as Smart Stake is not yet an operator on them.
          </li>
          <li>This is an experimental dashboard.</li>
        </ul>
      </Collapse>
    );
  }

  static networkNameFormatterTableWithLogo(cell, row, index, extraData) {
    if (!cell) {
      return "";
    }

    let label = MainUtils.getNameLabelShorter(cell);

    if (extraData != null) {
      label = label + extraData;
    }

    const onClick = e => e.stopPropagation();
    return (<span onClick={ onClick }><a className="tourValName animLinkTable"
      href={"/network/" + row.symbol}>{LogoUtils.projectLogo(
      row.logoPath, row, "logoStyleWithName")}&nbsp;&nbsp;{label}</a></span>);
  }

  static networkNameFormatterTableWithLogoNoTrim(cell, row, index, extraData) {
    if (!cell) {
      return "";
    }

    let label = cell;

    if (extraData != null) {
      label = label + extraData;
    }

    const onClick = e => e.stopPropagation();
    return (<span onClick={ onClick }><a className="tourValName animLinkTable"
      href={"/network/" + row.symbol}>{LogoUtils.projectLogo(
      row.logoPath, row, "logoStyleWithName")}&nbsp;&nbsp;{label}</a></span>);
  }

  static formatCoins(cell, row) {
    if (!cell) {
      return cell;
    }

    if (RespUtils.isMobileView()) {
      let value = numeral(cell).format('0[.]00');
      return value;
    }

    return Math.floor(cell).toLocaleString();
  }

  static async loadChainConfig(thisObj) {
    let url = "https://static.smartstake.io/resources/chainConfig.json";

    fetch(url, { referrerPolicy: "no-referrer" })
      .then(thisObj.handleErrors)
      .then((res) => res.json())
      .then((data) => {
        // console.log(data);
        let chains = data["chains"];

        if (chains && chains.length !== 0) {
          thisObj.setState({ chainConfig: chains, isLoadingChains: false });
        }
      })
      .catch((error) => console.log(error));
  }

  static getGithub() {
    return (<a href="https://github.com/SmartStake/relayers" target="_blank" title="github" className="mediaCustom fab fa-github fa-md">
        &nbsp;<span className="animLinkVisual">Github</span>
       </a>);
  }
}

export default RelayerUtils;
